import React, { useState } from "react";
import {
  Typography,
  Container,
  Card,
  CardContent,
  Box,
  Button,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import EnquiryDialog from "./EnquiryDialog"; // Import the EnquiryDialog component
import { Brush, Campaign, Check, Map, Web } from "@mui/icons-material";

export default function Pricing(props) {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTitle, setSelectedTitle] = useState("");

  const handleOpenDialog = (title) => {
    setSelectedTitle(title);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <Box sx={{ backgroundColor: "white", py: 4 }}>
      <Container
        maxWidth="lg"
        style={{
          marginTop: "2rem",
          backgroundColor: "white",
          marginBottom: "2rem",
        }}
        gutterBottom
      >
        <Typography
          data-aos="fade-up"
          sx={{ textAlign: "center", color: "#254749", fontWeight: "bold" }}
          variant="h4"
          style={{ marginBottom: "2rem" }}
          gutterBottom
        >
          Explore Our Services & Pricing
        </Typography>
        <Typography
          sx={{ textAlign: "center" }}
          variant="body1"
          style={{ marginBottom: "1rem" }}
          gutterBottom
          data-aos="fade-up"
          data-aos-delay="300"
        >
          Choose the right service for your business. We're here to help you
          succeed!
        </Typography>

        <Grid container spacing={3} alignItems="center">
          {/* Web Design Service */}
          <Grid
            item
            size={{ xs: 12, sm: 6, md: 3 }}
            gutterBottom
            data-aos="zoom-in"
            data-aos-delay="300"
          >
            <Card
              sx={{
                borderRadius: 6,
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    color: "#FA541C",
                  }}
                  display="flex"
                  justifyContent="center"
                  mb={2}
                >
                  <Web sx={{ fontSize: "64px", marginTop: "0px" }} />
                </Box>
                <Typography
                  sx={{
                    textAlign: "center",
                    color: "#011b46",
                  }}
                  variant="h6"
                  gutterBottom
                >
                  Web Design
                </Typography>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    Custom Website Development
                  </Typography>
                </Grid>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    Responsive Design
                  </Typography>
                </Grid>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    E-commerce Solutions
                  </Typography>
                </Grid>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    SEO Optimization
                  </Typography>
                </Grid>

                <Button
                  sx={{ width: "100%", mt: 2 }}
                  variant="contained"
                  color="primary"
                  onClick={() => handleOpenDialog("Web Design")}
                >
                  Enquire
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Digital Marketing Service */}
          <Grid
            item
            size={{ xs: 12, sm: 6, md: 3 }}
            gutterBottom
            data-aos="zoom-in"
            data-aos-delay="600"
          >
            <Card
              sx={{
                borderRadius: 6,
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    color: "#FA541C",
                  }}
                  display="flex"
                  justifyContent="center"
                  mb={2}
                >
                  <Campaign sx={{ fontSize: "64px", marginTop: "0px" }} />
                </Box>
                <Typography
                  sx={{
                    textAlign: "center",
                    color: "#011b46",
                  }}
                  variant="h6"
                  gutterBottom
                >
                  Digital Marketing
                </Typography>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    Social Media Marketing
                  </Typography>
                </Grid>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    Pay-Per-Click Campaigns
                  </Typography>
                </Grid>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    Email Marketing
                  </Typography>
                </Grid>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    SEO & Content Strategy
                  </Typography>
                </Grid>

                <Button
                  sx={{ width: "100%", mt: 2 }}
                  variant="contained"
                  color="primary"
                  onClick={() => handleOpenDialog("Digital Marketing")}
                >
                  Enquire
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* GIS Services */}
          <Grid
            item
            size={{ xs: 12, sm: 6, md: 3 }}
            gutterBottom
            data-aos="zoom-in"
            data-aos-delay="900"
          >
            <Card
              sx={{
                borderRadius: 6,
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    color: "#FA541C",
                  }}
                  display="flex"
                  justifyContent="center"
                  mb={2}
                >
                  <Map sx={{ fontSize: "64px", marginTop: "0px" }} />
                </Box>
                <Typography
                  sx={{
                    textAlign: "center",
                    color: "#011b46",
                  }}
                  variant="h6"
                  gutterBottom
                >
                  GIS Services
                </Typography>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    Geographic Data Analysis
                  </Typography>
                </Grid>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    Custom GIS Mapping
                  </Typography>
                </Grid>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    Remote Sensing & Imagery
                  </Typography>
                </Grid>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    GIS Consulting
                  </Typography>
                </Grid>

                <Button
                  sx={{ width: "100%", mt: 2 }}
                  variant="contained"
                  color="primary"
                  onClick={() => handleOpenDialog("GIS Services")}
                >
                  Enquire
                </Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Art Sales */}
          <Grid
            item
            size={{ xs: 12, sm: 6, md: 3 }}
            gutterBottom
            data-aos="zoom-in"
            data-aos-delay="1200"
          >
            <Card
              sx={{
                borderRadius: 6,
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    color: "#FA541C",
                  }}
                  display="flex"
                  justifyContent="center"
                  mb={2}
                >
                  <Brush sx={{ fontSize: "64px", marginTop: "0px" }} />
                </Box>
                <Typography
                  sx={{
                    textAlign: "center",
                    color: "#011b46",
                  }}
                  variant="h6"
                  gutterBottom
                >
                  Art Sales
                </Typography>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    Original Artworks for Sale
                  </Typography>
                </Grid>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    Custom Art Commissions
                  </Typography>
                </Grid>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    Art Exhibitions and Shows
                  </Typography>
                </Grid>

                <Grid container spacing={1} gutterBottom>
                  <Check sx={{ color: "green", marginRight: 1 }} />
                  <Typography variant="body1" style={{ fontSize: "small" }}>
                    Digital Art and Prints
                  </Typography>
                </Grid>

                <Button
                  sx={{ width: "100%", mt: 2 }}
                  variant="contained"
                  color="primary"
                  onClick={() => handleOpenDialog("Art Sales")}
                >
                  Enquire
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* Enquiry dialog component */}
      <EnquiryDialog
        open={openDialog}
        onClose={handleCloseDialog}
        title={selectedTitle}
      />
    </Box>
  );
}
